import { FilterConstraint } from '@marageti/z4-sdk/lib/entity';
import { ReviewStatus } from '@marageti/z4-sdk/lib/travel';
import { ChipOption } from '@marageti/z4-lib';

export const REVIEW_PUBLICATION_STATUS = {
  DRAFT: 'draft',
  UNPUBLISHED: 'unpublished',
  PUBLISHED: 'published',
} as const;

export const statusChipOptions: ChipOption[] = [
  { key: 0, label: 'Draft', value: REVIEW_PUBLICATION_STATUS.DRAFT },
  { key: 1, label: 'Unpublished', value: REVIEW_PUBLICATION_STATUS.UNPUBLISHED },
  { key: 2, label: 'Published', value: REVIEW_PUBLICATION_STATUS.PUBLISHED },
];

export const buildReviewPublicationStatusFilters = (selected: string[]): FilterConstraint[] => {
  if (!selected.length || selected.length === 3) return [];

  const draft = selected.includes(REVIEW_PUBLICATION_STATUS.DRAFT);
  const unpublished = selected.includes(REVIEW_PUBLICATION_STATUS.UNPUBLISHED);
  const published = selected.includes(REVIEW_PUBLICATION_STATUS.PUBLISHED);

  if (draft && !unpublished && !published) {
    return [{ field: 'status', value: [ReviewStatus.ReviewStatusPending] }];
  }

  if (!draft && unpublished && !published) {
    return [
      { field: 'status', value: [ReviewStatus.ReviewStatusCompleted] },
      { field: 'published', value: ['false'] },
    ];
  }

  if (!draft && !unpublished && published) {
    return [
      { field: 'status', value: [ReviewStatus.ReviewStatusCompleted] },
      { field: 'published', value: ['true'] },
    ];
  }

  if (!draft && unpublished && published) {
    return [{ field: 'status', value: [ReviewStatus.ReviewStatusCompleted] }];
  }

  if (draft && unpublished && !published) {
    return [
      { field: 'status', value: [ReviewStatus.ReviewStatusPending, ReviewStatus.ReviewStatusCompleted] },
      { field: 'published', value: ['false'] },
    ];
  }

  if (draft && published && !unpublished) {
    return [{ field: 'status', value: [ReviewStatus.ReviewStatusPending, ReviewStatus.ReviewStatusCompleted] }];
  }

  return [];
};
